module.exports = __webpack_public_path__ + "img/liste-soin-part-1.10d48f19.jpeg";